<template>
  <div>
    <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="$tx('hygl.components.attach', '附件')" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
      <div>
        <el-table ref="table" v-loading="loading" :data="tableData" border class="jxzb-tables">
          <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
          <el-table-column prop="fileName" :label="$tx('hygl.components.fileName', '文件名')" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="fileSize" :label="$tx('hygl.components.fileSize', '文件大小')" width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="uploadTime" :label="$tx('hygl.components.uploadTime', '上传时间')" width="160" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="uploadBy" :label="$tx('hygl.components.uploadBy', '上传人')" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="attachCount" :label="$tx('pageBtns.operate', '操作')" width="70" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <el-link v-pageBtn-lbl="'down'" :underline="false" @click="download(scope.row)">下载</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'cancel'" @click="toClose">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog v-if="dialogInfoVisible" v-el-drag-dialog :title="$tx('hygl.components.ytRecord', '议题纪要')" :visible.sync="dialogInfoVisible" width="1000px" :destroy-on-close="true" @close="toClose">
      <div>
        <el-form>
          <div style="width: 100%" class="el-table el-table--fit el-table--border">
            <div class="el-table__body-wrapper">
              <table v-loading="loading" cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                <tbody>
                  <tr>
                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                      <span v-field-lbl="'hyyt'" class="field">会议议题</span>
                    </td>
                    <td class="el-table__cell tdcont tdw83" colspan="5">
                      <div style="line-height: 26px">{{ rowData.subject }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                      <span v-field-lbl="'reportPersonName'" class="field">陈述人</span>
                    </td>
                    <td class="el-table__cell tdcont tdw33" colspan="2">
                      <span>{{ rowData.reportPersonName }}</span>
                    </td>
                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                      <span v-field-lbl="'mainDept'" class="field">主办部门</span>
                    </td>
                    <td class="el-table__cell tdcont tdw33" colspan="2">
                      <div style="line-height: 26px">{{ rowData.mainDept }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                      <span v-text-lbl="'hygl.components.ytRecord'" class="field">议题纪要</span>
                    </td>
                    <td class="el-table__cell tdcont tdw83" colspan="5" @click="meetingMinutesClick(rowData)">
                      <div style="line-height: 26px">{{ rowData.resolution }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td ref="tdlbl_附件" v-field-lbl="'attach'" class="el-table__cell tdlbl tdw17">附件</td>
                    <td class="el-table__cell tdcont tdcont" colspan="5">
                      <Attachment ref="attachments" wf-attach-url="hygl/hyapYtInfo" :vo="vo" :is-required="0" accept="*.*" empty-message="" :limit-count="10" online-editor="" online-file="" :attachments="rowData.passenger.attachments" :attachs-type="'ATTACH'" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-text-lbl="'pre'" :disabled="isLastBtn" icon="el-icon-arrow-left" @click="changHanle('last')">上一个</el-button>
        <el-button :disabled="isNextBtn" @click="changHanle('next')">
          <span v-text-lbl="'next'">下一个</span>
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </span>
    </el-dialog>
    <summary-dialog ref="summary_dialog"></summary-dialog>
  </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            if (val) {
                return moment(val).format('YYYY-MM-DD HH:mm')
            } else {
                return ''
            }
        }
    },
    components: {},
    props: {
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'hyap',
            dialogVisible: false,
            dialogInfoVisible: false,
            loading: false,
            tableData: [],
            downloadUrl: '',
            rowData: {},
            isLastBtn: false,
            isNextBtn: false,
            currentIndex: 0
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openMeetFileDialog', this.openMeetFileDialog)
        this.$options.components['summary-dialog'] = this.$loadComponent('@/wapp/hygl/components/hytzHygl/HyglHytzHyglSummaryDialog')
    },
    beforeDestroy() {
        this.$bus.off('openMeetFileDialog', this.openMeetFileDialog)
    },
    mounted() {},
    methods: {
        openMeetFileDialog(value, type = 0, row, index) {
            if (type === 1) {
                this.rowData = row
                this.tableData = value
                this.currentIndex = index
                if (this.rowData.passenger.attachIds) {
                    this.rowData.passenger.attachments = this.rowData.passenger.attachIds
                }

                this.loading = true
                this.isLastBtn = false
                this.isNextBtn = false

                if (this.currentIndex <= 0) {
                    this.isLastBtn = true
                }
                if (this.currentIndex >= this.tableData.length - 1) {
                    this.isNextBtn = true
                }

                this.dialogInfoVisible = true
                this.loading = false
            } else {
                this.tableData = value
                this.downloadUrl = ''
                this.dialogVisible = true
            }
        },
        // 切换
        changHanle(type) {
            this.loading = true
            this.isLastBtn = false
            this.isNextBtn = false

            if (type === 'last') {
                // 上一个
                this.currentIndex = (this.currentIndex - 1) % this.tableData.length // 切换到上一条数据
            } else if (type === 'next') {
                // 下一个
                this.currentIndex = (this.currentIndex + 1) % this.tableData.length // 切换到下一条数据
            }

            if (this.currentIndex <= 0) {
                this.isLastBtn = true
                this.currentIndex = 0
            }
            if (this.currentIndex >= this.tableData.length - 1) {
                this.isNextBtn = true
                this.currentIndex = this.tableData.length - 1
            }

            console.log('currentIndex', this.currentIndex)

            setTimeout(() => {
                this.rowData = this.tableData[this.currentIndex]
                this.loading = false
            }, 100)
        },
        // 下载
        download(row) {
            var href = `/apigw/hygl/ytRecord/downloadById?attachIds=${row.id}&topdf=false`
            var tempLink = document.createElement('a') // 创建一个a标签
            tempLink.style.display = 'none'
            tempLink.href = encodeURI(href)
            tempLink.setAttribute('download', row.fileName) // 给a标签添加下载属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            document.body.appendChild(tempLink) // 将a标签添加到body当中
            console.log('tempLink==', tempLink)
            tempLink.click() // 启动下载
            document.body.removeChild(tempLink) // 下载完毕删除a标签
            href = ''
        },
        meetingMinutesClick(row) {
            var _this = this
            if (!this.$vnode.context.canShowOption) return false

            this.$refs.summary_dialog.openSummaryDialog(row, true, (value) => {
                console.log('value==', value)
                if (value) {
                    row.resolution = value
                } else {
                    _this.getListData()
                }
            })
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
            this.dialogInfoVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
</style>
